module.exports = __webpack_public_path__ + "img/bg-mobile.3f5e9fab.jpg";